import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeMovementsActionAsync } from '../redux/actions/typeMovementActions'

export const useTypeMovement = () => {
  const { typeMovementsState } = useSelector(
    (state: RootState) => state.typeMovement
  )
  const dispatch = useDispatch()

  const getTypeMovements = () => {
    dispatch(getTypeMovementsActionAsync())
  }

  return { typeMovementsState, getTypeMovements }
}

export default useTypeMovement
